<template>
  <b-card class="card" no-body>
    <b-container class="template">
      <b-row class="service-section" align-v="center">
        <b-col cols="6" class="image-col">
          <img src="/assets/images/ocr.svg">
        </b-col>
        <b-col>
          <b-container class="service-container">
            <b-row class="row-ocr">
              <b-container>
                <b-row>
                  <div class="title-ocr">
                    Optical Character Recognition (OCR)
                  </div>
                </b-row>
                <b-row>
                  <div class="desc-ocr">
                    ค้นหาข้อความในรูปภาพและแปลงกลับเป็นตัวหนังสือ เช่น ข้อความในภาพถ่าย หรือเอกสารที่ได้มาจากการ scan
                  </div>
                </b-row>
                <b-row>
                  <div @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'OCR_home_page', linkTo: 'ocr' })">
                    <router-link
                      to="/demo/ocr"
                      class="title-button btn btn-primary"
                      exact
                      tag="button"
                    >
                      ทดลองใช้งาน
                    </router-link>
                  </div>
                </b-row>
              </b-container>
            </b-row>
            <b-row class="row-addr">
              <b-container>
                <b-row>
                  <div class="title-addr">
                    Address Extract
                  </div>
                </b-row>
                <b-row>
                  <div class="desc-addr">
                    ค้นหา ชื่อผู้รับ/ผู้ส่ง, ตำบล, อำเภอ, จังหวัด, รหัสไปรษณีย์ และเบอร์โทรศัพท์ในข้อความพร้อมกับคืนตำแหน่งที่พบข้อมูล
                  </div>
                </b-row>
                <b-row>
                  <div @click="trackCustomEvent({ inPage: routeName, action: 'clicked', target: 'address_home_page', linkTo: 'address' })">
                    <router-link
                      to="/demo/address"
                      class="title-button btn btn-primary"
                      exact
                      tag="button"
                    >
                      ทดลองใช้งาน
                    </router-link>
                  </div>
                </b-row>
              </b-container>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="example-desc-section justify-content-md-center" align-v="center">
        <div class="desc-example">
          ตัวอย่างการใช้งาน OCR และ Address Extract ร่วมกันเพื่อ อ่านที่อยู่จากหน้ากล่องพัสดุ
        </div>
      </b-row>
      <b-row class="example-step-section justify-content-md-center">
        <b-col class="step" xs="12" sm="12" md="12" lg="2" xl="2">
          <img class="example-step-icon" src="/assets/images/ocr_ex_1.svg">
          <div class="example-step-text">
            ที่อยู่บนกล่องพัสดุ
          </div>
        </b-col>
        <b-col class="arrow">
          <img class="example-step-arrow" src="/assets/images/arrow.svg">
        </b-col>
        <b-col class="step" xs="12" sm="12" md="12" lg="2" xl="2">
          <img class="example-step-icon" src="/assets/images/ocr_ex_2.svg">
          <div class="example-step-text">
            ถ่ายรูปที่อยู่จากหน้ากล่องพัสดุ
          </div>
        </b-col>
        <b-col class="arrow">
          <img class="example-step-arrow" src="/assets/images/arrow.svg">
        </b-col>
        <b-col class="step" xs="12" sm="12" md="12" lg="2" xl="2">
          <img class="example-step-icon" src="/assets/images/ocr_ex_3.svg">
          <div class="example-step-text">
            ใช้ OCR ค้นหาข้อความในรูปภาพ และแปลงออกมาเป็นตัวอักษร
          </div>
        </b-col>
        <b-col class="arrow">
          <img class="example-step-arrow" src="/assets/images/arrow.svg">
        </b-col>
        <b-col class="step" xs="12" sm="12" md="12" lg="2" xl="2">
          <img class="example-step-icon" src="/assets/images/ocr_ex_4.svg">
          <div class="example-step-text">
            Address Extract ค้นหาและจัดเรียง ชื่อ-ที่อยู่และข้อมูลต่างๆ ในข้อความ
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import { BCard, BContainer, BRow, BCol } from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  name: 'OCRCard',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    })
  }
}
</script>

<style scoped>

    .card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 20px #523F690D;
        border-radius: 4px;
        opacity: 1;
        width: 100%;
        height: 100%;
        padding: 105px 87px;
    }

    @media (max-width: 1379px) {
        .image-col {
            display: none;
        }

        .service-container::after {
            content: "";
            background-image: url('/assets/images/ocr.svg');
            background-repeat: no-repeat;
            background-position: center;
            opacity: 0.3;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    .title-ocr {
        font-size: 26px;
        font-weight: 500;
        color: #48465B;
        margin-bottom: 15px;
    }

    .desc-ocr {
        font-size: 14px;
        color: #6C757D;
        margin-bottom: 18px;
    }

    .row-ocr {
        margin-bottom: 50px;
        position: relative;
        z-index: 2;
    }

    .title-addr {
        font-size: 26px;
        font-weight: 500;
        color: #48465B;
        margin-bottom: 15px;
    }

    .desc-addr {
        font-size: 14px;
        color: #6C757D;
        margin-bottom: 18px;
    }

    .row-addr {
        position: relative;
        z-index: 2;
    }

    .service-section {
        margin-bottom: 90px;
    }

    .desc-example {
        color: #48465B;
        font-size: 22px;
        font-weight: 600;
        text-align: center;
    }

    .example-desc-section {
        margin-bottom: 39px;
    }

    .step {
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/
    }

    .example-step-icon {
        margin-bottom: 34px;
    }

    .example-step-text {
        font-size: 14px;
        color: #6C757D;
        text-align: center;
    }

    .arrow {
        display: flex;
        justify-content: center;
        align-items: baseline;
        margin-top: 60px;
    }

    @media (max-width: 1025px) {

        .example-step-icon {
            display: block;
            margin-right: auto;
            margin-left:auto;
            max-height: 250px;
            max-width: 250px;
            margin-bottom: 15px;
        }

        .example-step-arrow {
            transform: rotate(90deg);
        }

        .arrow {
            margin-top: 45px;
            margin-bottom: 45px;
        }
    }

</style>
